import React from 'react';
type Variant = 'deep-mid' | 'mid-gold' | 'navy-ivory' | 'ivory-navy' | 'mid-deep' | 'deep-deep';
type Props = {
  variant: Variant;
  height?: string;
};
const map: Record<Variant, string> = {
  'deep-mid': 'bridge-deep-mid',
  'mid-gold': 'bridge-mid-gold',
  'navy-ivory': 'bridge-navy-ivory',
  'ivory-navy': 'bridge-ivory-navy',
  'mid-deep': 'bridge-mid-deep',
  'deep-deep': 'bg-navy-deep'
};
export const SectionBridge: React.FC<Props> = ({
  variant,
  height = 'h-32 lg:h-48'
}) => <div className={`relative w-full ${height} ${map[variant]}`} aria-hidden="true" data-id="element-57" />;